import { render } from "./selectBox.vue?vue&type=template&id=847231e4"
import script from "./selectBox.vue?vue&type=script&lang=js"
export * from "./selectBox.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__